/* eslint-disable no-useless-escape */

export const validateEmail = (value: string) => {
  const emailRegex =
    // eslint-disable-next-line max-len
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return emailRegex.test(value) ? '' : 'Please enter valid Email';
};

//this function will validate password
export const validatePassword = (password: string) => {
  const passwordRegex = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,}/;
  return password.match(passwordRegex) ? '' : 'Enter valid password';
};

export const validateNumber = (value: string) => {
  const numberRegex = /^-?\d+(\.\d+)?$/;
  if (value === '') return true;

  if (numberRegex.test(value)) return value;
};

export const numberWithCommas = (x: number | string) => {
  // if (!x) return '0';
  // return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  const stringValue = typeof x === 'number' ? x.toString() : x;
  // Check if the number is a whole number or decimal number
  const filteredValue = parseFloat(stringValue).toString();

  if (stringValue.indexOf('.') === -1) {
    return filteredValue.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  // Separate the whole number part from the decimal part

  const parts = filteredValue.split('.');
  const wholeNumber = parts[0];
  let decimalPart = parts[1];
  // make sure the decimal part has only 2 digits
  decimalPart = decimalPart ? decimalPart.substr(0, 2) : '';

  // Add commas to the whole number part
  const formattedWholeNumber = wholeNumber.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  // Combine the whole number and decimal part (if exists) with a dot
  const formattedNumber = `${formattedWholeNumber}.${decimalPart}`;

  return formattedNumber;
};

export const numberWithoutCommas = (x: string) => {
  if (!x) return '0';

  // check if . is present in the number
  if (x.indexOf('.') === -1) {
    return x.toString().replace(/,/g, '');
  }

  const parts = x.split('.');
  const wholeNumber = parts[0];
  const decimalPart = parts[1];

  // remove commas from the whole number part
  const formattedWholeNumber = wholeNumber.replace(/,/g, '');
  const formattedDecimalPart = decimalPart.replace(/,/g, '');

  // combine the whole number and decimal part (if exists) with a dot
  const formattedNumber = `${formattedWholeNumber}.${formattedDecimalPart}`;

  return formattedNumber;

  // return x.toString().replace(/,/g, '');
};
